module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/g-authorization-callback/g-authorization-callback.component.html
// module id = ./src/app/g-authorization-callback/g-authorization-callback.component.html
// module chunks = main